import { LOADING_PLACEHOLDER_ID } from './elementIds'

export function showLoadingSpinner(): void {
  getLoadingPlaceholder()!.style.display = 'block'
}

export function hideLoadingSpinner(): void {
  getLoadingPlaceholder()!.style.display = 'none'
}

function getLoadingPlaceholder(): HTMLElement | null {
  return document.getElementById(LOADING_PLACEHOLDER_ID)
}
